module.exports = __webpack_public_path__ + "static/media/latest_values.7f449909.png";